import { useKeyboardControls } from "@react-three/drei"
import useGame from "./stores/useGame"
import { useEffect, useRef } from "react"
import { addEffect } from "@react-three/fiber"
export default function Interface() {

    const controls = useKeyboardControls((state)=>state)
    const forward = controls.forward
    const backward = controls.backward
    const left = controls.left
    const right = controls.right
    const jump = controls.jump
    const restart = useGame((state)=>state.restart)
    const phase = useGame((state)=>state.phase)
    const time = useRef()
    useEffect(()=>{
        {
            const unsubscribeEffect = addEffect(()=>{
                const state = useGame.getState()
                // console.log(state)
                let elapsedTime = 0
                if (state.phase == "playing"){
                    elapsedTime= Date.now() - state.startTime

                }
                else if(state.phase == "ended"){
                    elapsedTime = state.endTime - state.startTime
                }
                elapsedTime /=1000
                elapsedTime = elapsedTime.toFixed(2)
                // console.log(elapsedTime)
                if (time.current){
                    time.current.textContent = `${elapsedTime}s`
                }
            })
            return()=>{
                unsubscribeEffect()
            }
        }

    },[])
    return( 
        <div className="interface">

            {/* <!-- Timer --> */}
            <div ref={time} className="time">
                0.00
            </div>
            

            {/* <!-- Restart --> */}
            { phase==="ended" &&
            <div className="restart" onClick={restart}>
                RESTART
            </div>
            }

            {/* Controls */}
        <div className="controls">
            <div className={`key ${forward ? "active" : ""}`}>W</div>
            <div className={`key ${left ? "active" : ""}`}>A</div>
            <div className={`key ${backward ? "active" : ""}`}>S</div>
            <div className={`key ${right ? "active" : ""}`}>D</div>
            <div className={`key wide ${jump ? "active" : ""}`}>SPACE</div>
        </div>
        </div>

    )
}